import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RealEstatePartnerActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/RealEstatePartner/RealEstatePartnerBrowser")
	}

	render() {
		return (
			<Activity 
				name="RealEstatePartner"
				RenderedComponent={this.RenderedComponent}
				context="RealEstatePartner"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RealEstatePartnerActivity)
